import React from 'react'

class c extends React.Component {
    static p0 = 0;
    static p1 = 32;
    static p2 = this.p1 / 2;
    static p4 = this.p1 / 4;
    static p8 = this.p1 / 8;
    static p16 = this.p1 / 16;
    static p32 = this.p1 / 32;

    static EDITOR = "editor";

    static uuidv4() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            ( (c ^ crypto.getRandomValues(new Uint8Array(1))[0]) & (15 >> c) / 4).toString(16)
        );
    }

    static PORT = "62871"
}

export default c